let menubar = (function () {

    let overlay = null,
        visible = false,
        container = document.querySelector('.js-menubar-nav');

    return {
        open() {
            const html = document.querySelector('html');

            container.classList.toggle('menubar-nav_visible');
            // build overlay
            overlay = document.createElement('div');
            overlay.setAttribute('class', 'menubar-overlay');
            document.body.appendChild(overlay);

            // remove the scroll
            html.setAttribute('style', 'overflow: hidden');

            visible = true;
        },
        close() {
            const html = document.querySelector('html');

            container.classList.toggle('menubar-nav_visible');
            // remove overlay
            document.body.removeChild(overlay);

            // remove the scroll
            html.setAttribute('style', 'overflow: scroll');

            visible = false;
        },
        isVisible() {
            return visible
        },
    }
})();

document.addEventListener('DOMContentLoaded', function () {
    // Open mobile menu js-open-mobile-menu
    const buttonOpenMenu = document.querySelector('.js-open-mobile-menu');

    buttonOpenMenu.addEventListener('click', () => {
        menubar.open();
    });

    // Close mobile menu js-open-mobile-menu
    const buttonCloseMenu = document.querySelector('.js-close-mobile-menu');

    buttonCloseMenu.addEventListener('click', () => {
        menubar.close();
    });

    // mobile menu
    const items = document.querySelectorAll('.js-menubar-list .menu-item-has-children a[href*="#"]');

    for (let item of items) {
        item.addEventListener('click', function(e) {
            e.preventDefault();
            item.parentNode.classList.toggle('menu-item-has-children_active');
        });
    }
});

document.addEventListener('DOMContentLoaded', () => {
    const logouts = document.querySelectorAll('ngp-auth-logout');

    [...logouts].forEach(logout => {
        logout.addEventListener('click', () => {
            document.body.classList.remove('register');
            document.body.classList.add('no-register');
        });
    });
});
